import React from "react";
import { useHistory } from "react-router-dom";

const DashboardCard = ({ title, cardtext, url }) => {
  const history = useHistory();
  return (
    <>
      <div className="col-sm-4 shadow-sm p-2 bg-white rounded">
        <div className="card border-dark mb-23">
          {/*<div className="card-header">Taxonomy</div>*/}
          <div className="card-body text-dark">
            <h5 className="card-title">{title}</h5>
            <p className="card-text">{cardtext}</p>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => history.push(url)}
            >
              Explore
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default DashboardCard;
